package at.theatervogelweide.admin.web.screens

import androidx.compose.runtime.Composable
import at.theatervogelweide.admin.web.Route
import at.theatervogelweide.admin.web.components.AdminCard
import at.theatervogelweide.admin.web.components.AdminPageBody
import at.theatervogelweide.admin.web.components.AdminPageHeader
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun NotFoundScreen(onNavigate: (Route) -> Unit) {
    AdminPageHeader("Seite nicht gefunden")

    AdminPageBody {
        AdminCard(title = "Diese Adresse gibt es nicht", id = "nicht-gefunden") {
            P {
                A(Route.Overview.path, {
                    onClick { event ->
                        event.preventDefault()
                        onNavigate(Route.Overview)
                    }
                }) { Text("Zur Übersicht") }
            }
        }
    }
}
